import {
  Component,
  OnInit,
  Input,
  EventEmitter,
  Output,
  OnChanges,
  SimpleChanges,
  AfterViewInit,
  ViewChild,
  ElementRef,
  Renderer2,
  ChangeDetectorRef,
  OnDestroy,
} from "@angular/core";
import { OnboardingService } from "../../shared/service/onboarding.service";
import { OnboardingHRDetail } from "../../shared/models/OnboardingHRDetail";
import { ActivatedRoute, Router } from "@angular/router";
import { SafeUrl, DomSanitizer } from "@angular/platform-browser";
import { ToastrService } from "ngx-toastr";
import { DatePipe, formatDate } from "@angular/common";
import { AppConfig } from "../../app.config";
import { UserService } from "../../shared/service/user.service";
import { DepartmentsService } from "../../shared/service/departments.service";
import { CadreService } from "../../shared/service/cadre.service";
import { EmployeeService } from "../../shared/service/employee.service";
import { BasicEmployeeDetails } from "../../shared/models/basicemployeedetails.model";
import { isUndefined, isNullOrUndefined } from "util";
import {
  MomentDateAdapter,
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
} from "@angular/material-moment-adapter";
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
  MatDateFormats,
} from "@angular/material/core";
import * as _moment from "moment";
import {
  FormGroup,
  FormBuilder,
  FormControl,
  AbstractControl,
  Validators,
  ValidationErrors,
  FormArray,
} from "@angular/forms";
import {
  DesignationDialog,
  DesignationDialogComponent,
} from "../../shared/components/designation-dialog/designation-dialog.component";
import {
  MatDialog,
  MatDatepickerInputEvent,
  MatCalendar,
} from "@angular/material";
import { MatAutocompleteTrigger } from "@angular/material/autocomplete";
import {
  TechGroupDialog,
  TechgroupDialogComponent,
} from "../../shared/components/techgroup-dialog/techgroup-dialog.component";
import {
  ExpDialog,
  ExpertiseDialogComponent,
} from "../../shared/components/expertise-dialog/expertise-dialog.component";
import { MatTableDataSource } from "@angular/material/table";
import { PeopleManagersHistoryDetails } from "../../shared/models/PeopleManagersHistoryDetails";
import {
  ConfirmDialogModel,
  ConfirmDialogComponent,
} from "../../shared/components/confirm-dialog/confirm-dialog.component";
import { HREmployeeDetails } from "../../shared/models/hremployeecommunicationdetails.model";
import { File_Types, Resume_File_Types } from "../../shared/UploadFileTypes";
import { Profile_File_Types } from "../../shared/UploadFileTypes";
import { FileUploadService } from "../../shared/service/fileUpload.service";
import { dataService } from "../../shared/service/dataservice.service";
import { SeniorManagersHistoryDetails } from "../../shared/models/SeniorManagersHistoryDetails";
import { usaStatesList } from "../../../Models/UsaMasterStatesList";
import { Streams } from "../../shared/models/Streams";
import { PrimarySkills } from "../../shared/models/PrimarySkills";
import { AdditionalSkills } from "../../shared/models/AdditionalSkills";

import {
  DepartmentDialog,
  DepartmentDialogComponent,
} from "../../shared/components/department-dialog/department-dialog.component";
import {
  CadreDialog,
  CadreDialogComponent,
} from "../../shared/components/cadre-dialog/cadre-dialog.component";
import { ExampleHeader } from "../../shared/pipes/date.directive";

export const MY_FORMATS = {
  parse: {
    dateInput: "DD-MMM-YYYY",
  },
  display: {
    dateInput: "DD-MMM-YYYY",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY",
  },
};

type TeamListCallback = (teamList: any[]) => void;
type EmpTypeListCallback = (eeTypeList: any[]) => void;
@Component({
  selector: "app-hr-basic-details",
  templateUrl: "./hr-basic-details.component.html",
  styleUrls: ["./hr-basic-details.component.css"],
  providers: [
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})
export class HrBasicDetailsComponent
  implements OnInit, OnChanges, AfterViewInit, OnDestroy {
  error: string;
  date: Date;
  HREmp: BasicEmployeeDetails;
  newAttribute: any = {};
  newAttributepm: any = {};
  HrDetailsForm: FormGroup;
  submitted = false;
  exception = false;
  designationsList: any;
  locationsList: any;
  departmentsList: any;
  cadresList: any;
  employeeType: string;
  datePipe: DatePipe;
  MAX_SIZE: number = 1048576;
  EmpDetform: FormGroup;
  @Output("employeeDet") employeeDet = new EventEmitter();
  @Input() empCode: any;
  @Input() groupId: any;
  @Output("HrEmpOutput") HrEmpOutput = new EventEmitter();
  @Output() dateChange: EventEmitter<MatDatepickerInputEvent<any>>;
  empList: any[];
  UserRolesList: any[];
  //@Input() hide: boolean;
  //@Input() required: boolean
  @Input() isProfile: boolean;
  isSaved: boolean;
  filteredList: any;
  filteredPMList: any;
  filteredSMList: any;
  filteredCadreList: any;
  tempPMList: pmObj[] = [];
  tempSMList: smObj[] = [];
  designationId: any;
  departmentId: any;
  cadreId: any;
  filteredDeptList: any;
  todayDate: Date;
  maxDate: Date;
  minDate: Date;
  currentYear: any;
  currentMonth: any;
  currentDate: any;
  presentDate = new Date();
  DOJMaxDate: any;
  Required: boolean = false;
  RequiredTech: boolean = false;
  RequiredDept: boolean = false;
  RequiredCadre: boolean = false;
  teamList: any;
  filteredTeamList: any;
  eeTypeList: any;
  techGroupList: any;
  expertiseList: any;
  TechGroupId: any;
  StreamId: any;
  PrimarySkillId: any;
  filteredTechList: any;
  @Output("filteredExpList") filteredExpList: any;
  expertiseId: any;
  astricbool: boolean = false;
  RequiredExp: boolean = false;
  result: any;
  LoginEmpCode: any;
  employeeDetails: HREmployeeDetails;
  EmpId: any;
  disableforMyProfile: boolean;
  approveCheckMyProfile: any;
  @Input() photo: string | SafeUrl;
  @Output() photoUpdated = new EventEmitter<string | SafeUrl>();
  showAddPhotoOverlay = false;
  image: string | SafeUrl;
  defaultLocation: boolean = false;
  usaStates: any = {};
  filteredLocationsList: any;
  @Input() ishidden: boolean;
  filteredeeTypeList: any;
  originalHrEmp: BasicEmployeeDetails;
  enableJoblocationState: boolean;
  enableDesignation: boolean;
  enableCadre: boolean;
  enableDepartment: boolean;
  enablePeopleManager: boolean;
  enableSeniorManager: boolean;
  enableLocation: boolean;
  enableDivision: boolean;
  enableExpertise: boolean;
  enableTechgroup: boolean;
  isInvalidUrl: boolean = false;
  StreamList: Streams[] = [];
  PrimarySkillsList: PrimarySkills[] = [];
  AdditionalSkillsList: any[] = [];
  filteredStreams: any;
  filteredPrimarySkills: any;
  filteredSecondarySkills: any;
  additionalSkills: FormArray = this.fb.array([]);
  private previousJobLocationStateStatus: string | null = null;
  private previousDesignationStatus: string | null = null;
  private previousCadre: string | null = null;
  private previousDepartment: string | null = null;
  private previousseniorManager: string | null = null;
  private previouspeopleManger: string | null = null;
  private previousLocation: string | null = null;
  private previousDivision: string | null = null;
  private previousExpertise: string | null = null;
  private previousTechgroup: string | null = null;
  fullDataLoading = true;
  destroyed = false;
  exampleHeader = ExampleHeader;
  costCenters: any[] = [];
  hasAddPermission: boolean = false;
  @ViewChild("peopleManagerInput", { static: false })
  peopleManagerInput!: ElementRef<HTMLInputElement>;
  @ViewChild("seniorManagerInput", { static: false })
  seniorManagerInput!: ElementRef<HTMLInputElement>;
  fileInputVisible = false;
  fileInputState = {
    resume: false,
    aadhar: false,
    panFile: false
  };

  private linkedInUrlPattern = /^(https?:\/\/)?(www\.)?(linkedin\.com\/.*)$/;

  onSelectFile(event) {
    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();

      reader.readAsDataURL(event.target.files[0]); // read file as data url

      reader.onload = (event: any) => {
        // called once readAsDataURL is completed
        this.HREmp.ProfileFilePath = event.target.result;
      };
      const files: FileList = event.target.files;
      //reader.readAsDataURL(files.item(0));
      if (files && files.length > 0) {
        if (!this.validFileType(files[0])) {
          this.toastr.warning(
            "File name " + files[0].name + ": Not a valid file type."
          );
        }
        // Don't allow file sizes over 1MB
        if (files[0].size < this.MAX_SIZE) {
          this.HREmp.ProfileFile = this.file_Svc.readAndUploadProfilePic(files);
        } else {
          this.toastr.warning(
            " File: " +
            files[0].name +
            " exceeds 1MB hence it cannot be uploaded."
          );
        }
      }
    }
  }
  disableDOE: boolean;
  constructor(
    private route: ActivatedRoute,
    private userService: UserService,
    public router: Router,
    private hrSvc: OnboardingService,
    public toastr: ToastrService,
    public file_Svc: FileUploadService,
    private cadreSvc: CadreService,
    private deptSvc: DepartmentsService,
    private emp_Svc: EmployeeService,
    public dialog: MatDialog,
    private SVC: dataService,
    private sanitizer: DomSanitizer,
    private cdr: ChangeDetectorRef,
    private config: AppConfig,
    private fb: FormBuilder,
  ) {
    this.datePipe = new DatePipe("en-US");
    this.todayDate = new Date();

    this.currentYear = new Date().getFullYear();
    this.currentMonth = new Date().getMonth();
    this.currentDate = new Date().getDate();
    this.DOJMaxDate = new Date(this.currentYear, this.currentMonth, this.currentDate + 7)
    //this.maxDate = new Date(
    //  this.currentYear + 1,
    //  this.currentMonth,
    //  this.currentDate
    //);
    this.route.params.subscribe((params) => {
      this.empCode = params["empCode"];

      this.initializeParamChange();
    });
  }

  initializeParamChange() {
    //get the login employee code
    this.LoginEmpCode = this.userService.getEmpCode().toString();
    this.EmpId = this.LoginEmpCode;
    if (!isNullOrUndefined(this.empCode)) {
      if (this.router.url.startsWith("/myprofile/")) {
        if (this.empCode === this.LoginEmpCode) this.isProfile = true;
        else this.router.navigate(["/EmployeeWithoutPermission"]);
      }
    }
  }

  checkPermission() {
    var permission = this.userService.userInfo.permissions.find(
      (i) => i.Menu === "Master"
    );
    this.hasAddPermission = permission != null ? permission.AddingPermission || permission.HasFullAccess : false;
  }

  ngOnInit() {
    this.fullDataLoading = true;
    this.cdr.detectChanges();
    //this.getSubmitMyProfileData();
    this.checkPermission();
    this.getEeType();
    this.usaStates = usaStatesList;
    this.HrDetailsForm.get("JobLocationState").statusChanges.subscribe(
      (status) => {
        if (
          this.previousJobLocationStateStatus === "DISABLED" &&
          status === "VALID"
        ) {
          this.enableJoblocationState = true;
          this.cdr.detectChanges();
        }
        this.previousJobLocationStateStatus = status;
      }
    );
    this.HrDetailsForm.get("Designation").statusChanges.subscribe((status) => {
      if (this.previousDesignationStatus === "DISABLED" && status === "VALID") {
        this.enableDesignation = true;
        this.cdr.detectChanges();
      }
      this.previousDesignationStatus = status;
    });
    this.HrDetailsForm.get("Cadre").statusChanges.subscribe((status) => {
      if (this.previousCadre === "DISABLED" && status === "VALID") {
        this.enableCadre = true;
        this.cdr.detectChanges();
      }
      this.previousCadre = status;
    });
    this.HrDetailsForm.get("Department").statusChanges.subscribe((status) => {
      if (this.previousDepartment === "DISABLED" && status === "VALID") {
        this.enableDepartment = true;
        this.cdr.detectChanges();
      }
      this.previousDepartment = status;
    });
    this.HrDetailsForm.get("Location").statusChanges.subscribe((status) => {
      if (this.previousLocation === "DISABLED" && status === "VALID") {
        this.enableLocation = true;
        this.cdr.detectChanges();
      }
      this.previousLocation = status;
    });
    this.HrDetailsForm.get("DivisionId").statusChanges.subscribe((status) => {
      if (this.previousDivision === "DISABLED" && status === "VALID") {
        this.enableDivision = true;
        this.cdr.detectChanges();
      }
      this.previousDivision = status;
    });
    this.HrDetailsForm.get("StreamId").statusChanges.subscribe((status) => {
      if (this.previousExpertise === "DISABLED" && status === "VALID") {
        this.enableExpertise = true;
        this.cdr.detectChanges();
      }
      this.previousExpertise = status;
    });
    this.HrDetailsForm.get("TechGroupId").statusChanges.subscribe((status) => {
      if (this.previousTechgroup === "DISABLED" && status === "VALID") {
        this.enableTechgroup = true;
        this.cdr.detectChanges();
      }
      this.previousTechgroup = status;
    });
    if (this.empCode == undefined || this.empCode == null) {
      this.fullDataLoading = false;
      this.cdr.detectChanges();
    }
  }

  ngAfterViewInit() {
    if (this.peopleManagerInput) {
      const peopleManagerInputElement = this.peopleManagerInput.nativeElement;

      // Listen for changes on the input element
      peopleManagerInputElement.addEventListener("input", (event: Event) => {
        const currentStatus = peopleManagerInputElement.disabled
          ? "DISABLED"
          : "VALID"; // Determine status
        if (
          this.previouspeopleManger === "DISABLED" &&
          currentStatus === "VALID"
        ) {
          this.enablePeopleManager = true;
          this.cdr.detectChanges();
        }

        this.previouspeopleManger = currentStatus;
      });
    }

    if (this.seniorManagerInput) {
      const seniorManagerInputElement = this.seniorManagerInput.nativeElement;

      // Listen for changes on the input element
      seniorManagerInputElement.addEventListener("input", (event: Event) => {
        const currentStatus = seniorManagerInputElement.disabled
          ? "DISABLED"
          : "VALID"; // Determine status

        if (
          this.previousseniorManager === "DISABLED" &&
          currentStatus === "VALID"
        ) {
          this.enableSeniorManager = true;
          this.cdr.detectChanges();
        }

        this.previousseniorManager = currentStatus;
      });
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    this.employeeDetails = new HREmployeeDetails();
    this.HREmp = new BasicEmployeeDetails();
    this.originalHrEmp = new BasicEmployeeDetails();
    if (isNullOrUndefined(this.empCode)) {
      this.HrEmpOutput.emit(this.HREmp);
      this.SVC.name = this.HREmp;
      this.newAttribute = {};
      this.HREmp.seniorManagersHistoryDetails.push(this.newAttribute);
      this.newAttributepm = {};
      this.HREmp.peopleManagersHistoryDetails.push(this.newAttributepm);
    }
    this.SVC.name = this.HREmp;
    this.getDesignations();
    this.GetTechGroup();
    this.FormInitialization();
   // this.getLocations();
    this.getDepartments();
   // this.getCadres();
    this.getUserRoles();
    this.deptSvc.fetchAndCacheEeTypeList('Team').subscribe((teamList) => {
      this.teamList = teamList.filter(
        (team) => team.Value != "Onshore"
      );
    });
    this.deptSvc.fetchAndCacheEeTypeList('EeType').subscribe((eeTypeList) => { this.eeTypeList = eeTypeList });
    this.getBasicEmployeeByCode();
    this.getEmployeeSMList();
    if (this.groupId == null) this.getEmployeeList();
    this.getStreams();
    this.getPrimarySkills();
    this.getAdditionalSkills();
    if (this.groupId != null) {
      this.fullDataLoading = true;
      this.emp_Svc
        .getEmployeeDetailsByGroupId(this.groupId)
        .subscribe((data: any) => {
          this.HREmp = data;
          this.HREmp.EmpCode = null;
          this.HREmp.Email = null;
          this.HREmp.DOJ = null;
          this.HREmp.ResignationDate = null;
          this.HREmp.DateOfExit = null;
          this.HREmp.Type = "Re-hire";
          this.HREmp.GPAInclusion = null;
          this.HREmp.GMCInclusion = null;
          this.HREmp.IsMigratedOnH1 = null;
          this.HREmp.ConsultantType = null;
          this.HREmp.EeTypeId = null;
          this.HREmp.EmpSubType = null;
          this.HREmp.FiveCStatus = null;
          this.designationId = null;
          this.cadreId = null;
          this.departmentId = null;
          this.HREmp.DepartmentId = null;
          this.HREmp.CadreId = null;
          this.HREmp.DesignationId = null;
          this.HREmp.peopleManagersHistoryDetails = [];
          this.HREmp.seniorManagersHistoryDetails = [];
          this.HREmp.TechGroupId = null;
          this.HrDetailsForm.get("EmployeeCode").setValue(null);
          this.getEmployeeList();
          if (this.HREmp.ProbationDate == null) {
            this.GetProbation(
              this.HREmp.DOJ,
              this.HREmp.TeamId,
              this.HREmp.EeTypeId
            );
          }
          if (this.HREmp.LocationID == 1 || this.HREmp.LocationID == 2) {
            this.disableDOE = true;
          } else this.disableDOE = false;
          if (!this.HREmp.CelebratedDOB) {
            this.HREmp.CelebratedDOB = this.HREmp.DOB;
          }

          if (
            this.HREmp.LocationID != null &&
            (this.HREmp.LocationID === 1 || this.HREmp.LocationID === 2) &&
            this.HREmp.JobLocationState == null
          ) {
            this.setJobLocationState();
          }
          if (this.HREmp.IsMigratedOnH1 && this.HREmp.DateOfExit != null) {
            this.setUSDOJ(this.HREmp.DateOfExit);
          }
          var seniorManager = new SeniorManagersHistoryDetails();
          this.setTeam(this.HREmp.LocationID);
          this.HREmp.seniorManagersHistoryDetails =
            this.HREmp.seniorManagersHistoryDetails.slice(0, 1);
          if (this.HREmp.seniorManagersHistoryDetails.length == 0) {
            this.newAttribute = {
              ID: 0,
              DurationFrom: "",
              DurationTo: "",
              Name: "",
              Designation: "",
            };
            this.HREmp.seniorManagersHistoryDetails.push(this.newAttribute);
            this.newAttribute = {};
          }
          var peopleManager = new PeopleManagersHistoryDetails();
          this.HREmp.peopleManagersHistoryDetails =
            this.HREmp.peopleManagersHistoryDetails.slice(0, 1);

          if (this.HREmp.peopleManagersHistoryDetails.length == 0) {
            this.newAttributepm = {
              ID: 0,
              DurationFrom: "",
              DurationTo: "",
              Name: "",
              Designation: "",
            };
            this.HREmp.peopleManagersHistoryDetails.push(this.newAttributepm);
            this.newAttributepm = {};
          }
          this.getEmployeeSMList();
          this.enableJoblocationState =
            this.isSaved && this.HREmp.JobLocationState != null ? false : true;
          this.enableLocation =
            this.isSaved && this.HREmp.LocationID != null ? false : true;
          this.enableDesignation =
            this.isSaved && this.HREmp.DesignationId != null ? false : true;
          this.cdr.detectChanges();
          this.enableCadre =
            this.isSaved && this.HREmp.CadreId != null ? false : true;
          this.cdr.detectChanges();
          this.enableDepartment =
            this.isSaved && this.HREmp.DepartmentId != null ? false : true;
          this.cdr.detectChanges();
          this.enableDivision =
            this.isSaved && this.HREmp.DivisionId != null ? false : true;
          this.enableSeniorManager =
            this.isSaved && this.HREmp.seniorManagersHistoryDetails[0].ID > 0
              ? false
              : true;
          this.enablePeopleManager =
            this.isSaved && this.HREmp.peopleManagersHistoryDetails[0].ID > 0
              ? false
              : true;
          this.cdr.detectChanges();
          this.designationsList.forEach((item) => {
            if (item.ID == this.HREmp.DesignationId) {
              this.designationId = item.DesignationName;
            }
          });
          if (this.departmentsList != null && this.departmentsList.length > 0) {
            this.departmentsList.forEach((item) => {
              if (item.ID == this.HREmp.DepartmentId) {
                this.departmentId = item.DepartmentName;
                this.enableExpertise =
                  this.isSaved &&
                    this.departmentId == "Delivery" &&
                    this.HREmp.ExpertiseId != "" &&
                    this.HREmp.ExpertiseId != null
                    ? false
                    : true;
                this.enableTechgroup =
                  this.isSaved &&
                    this.departmentId == "Delivery" &&
                    this.HREmp.TechGroupId != null
                    ? false
                    : true;
              }
            });
          }
          if (this.cadresList != null && this.cadresList.length > 0) {
            this.cadresList.forEach((item) => {
              if (item.ID == this.HREmp.CadreId) {
                this.cadreId = item.CadreName;
              }
            });
            this.cdr.detectChanges();
          }
          if (this.techGroupList != null && this.techGroupList.length > 0) {
            this.techGroupList.forEach((item) => {
              if (item.ID == this.HREmp.TechGroupId) {
                this.TechGroupId = item.GroupName;
              }
            });
          }
          const usdoj = this.HrDetailsForm.get("US_DOJ");
          const usdoe = this.HrDetailsForm.get("US_DOE");
          const oldloc = this.HrDetailsForm.get("OldLocation");
          if (this.HREmp.IsMigratedOnH1 && !this.isProfile) {
            usdoj.setValidators([Validators.required]);
            oldloc.setValidators([Validators.required]);
          } else {
            usdoj.clearValidators();
            usdoe.clearValidators();
            oldloc.clearValidators();
          }
          usdoj.updateValueAndValidity();
          usdoe.updateValueAndValidity();
          oldloc.updateValueAndValidity();
          this.getCommunicationDataByGroupId(this.groupId);
          this.onSelectedTechGroupId();
          this.profileFields();
          this.HREmp.ExpertiseId = data.ExpertiseId.split(",");
          this.originalHrEmp = JSON.parse(JSON.stringify(this.HREmp));
          this.fullDataLoading = false;
          this.HrEmpOutput.emit(this.HREmp);
        });
    }
  }

  // Method to reset EmpSubType
  resetEmpSubType() {
    if (
      (this.HREmp.ConsultantType != null &&
        this.originalHrEmp.ConsultantType != null &&
        this.originalHrEmp.ConsultantType != this.HREmp.ConsultantType) ||
      (this.HREmp.TeamId != null &&
        this.originalHrEmp.TeamId != null &&
        this.originalHrEmp.TeamId != this.HREmp.TeamId)
    ) {
      this.HREmp.EmpSubType = null;
      this.HrDetailsForm.get("EmpSubType").setValue(null);
    }
  }

  openFileInput(fileInput) {
    fileInput.click();
    this.showAddPhotoOverlay = false;
  }

  //handleProfileImg(event) {
  //  if (event.target.files && event.target.files[0]) {
  //    var reader = new FileReader();

  //    reader.readAsDataURL(event.target.files[0]); // read file as data url
  //    this.photo = this.sanitizer.bypassSecurityTrustUrl(
  //      window.URL.createObjectURL(event.target.files[0])
  //    );
  //    reader.onload = (event: any) => {
  //      // called once readAsDataURL is completed
  //      this.HREmp.ProfileFilePath = event.target.result;
  //    };
  //    const files: FileList = event.target.files;
  //    //reader.readAsDataURL(files.item(0));
  //    if (files && files.length > 0) {
  //      if (!this.validFileTypeProfile(files[0])) {
  //        this.toastr.warning(
  //          "File name " + files[0].name + ": Not a valid file type."
  //        );
  //      }
  //      // Don't allow file sizes over 1MB
  //      if (files[0].size < this.MAX_SIZE) {
  //        this.HREmp.ProfileFile = this.file_Svc.readAndUploadProfilePic(files);
  //        this.photoUpdated.emit(this.photo);
  //      } else {
  //        this.toastr.warning(
  //          " File: " +
  //            files[0].name +
  //            " exceeds 1MB hence it cannot be uploaded."
  //        );
  //      }
  //    }
  //  }
  //}


  handleProfileImg(event) {
    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();

      reader.readAsDataURL(event.target.files[0]); // read file as data url
      this.photo = this.sanitizer.bypassSecurityTrustUrl(
        window.URL.createObjectURL(event.target.files[0])
      );
      reader.onload = (event: any) => {
        // called once readAsDataURL is completed
        this.HREmp.ProfileFilePath = event.target.result;
      };
      const files: FileList = event.target.files;

      if (files && files.length > 0) {
        // Validate file type
        if (!this.validFileTypeProfile(files[0])) {
          this.toastr.warning(
            "File name " + files[0].name + ": Not a valid file type."
          );
          return false; // Validation failed
        }

        // Don't allow file sizes over 1MB
        if (files[0].size < this.MAX_SIZE) {
          this.HREmp.ProfileFile = this.file_Svc.readAndUploadProfilePic(files);
          this.photoUpdated.emit(this.photo);
          return true;
        } else {
          this.toastr.warning(
            "File: " +
            files[0].name +
            " exceeds 1MB hence it cannot be uploaded."
          );
          return false;
        }
      }
    }
    return false;
  }

  validFileTypeProfile(file) {
    let types = Profile_File_Types;
    return types.includes(file.type);
  }

  removePhoto() {
    this.photo = "";
    this.photoUpdated.emit(this.photo);
  }

  getSubmitMyProfileData() {
    this.emp_Svc
      .GetProfileVerificationStatus(this.LoginEmpCode)
      .subscribe((data: any) => {
        this.approveCheckMyProfile = data;
        if (this.isProfile == true) {
          for (var i = 0; i < data.length; i++) {
            this.disableforMyProfile = data[i].Submitted;
          }
        }
        if (this.disableforMyProfile == true) {
          this.EmpDetform.get("Aadhar").disable();
          this.EmpDetform.get("AadharFile").disable();
          this.HrDetailsForm.disable();
          this.EmpDetform.get("PAN").disable();
          this.EmpDetform.get("PanFile").disable();
        }
      });
  }

  getTeamValue(Id) {
    if (this.teamList != null) {
      for (var i = 0; i < this.teamList.length; i++) {
        if (this.teamList[i].ID == Id) {
          return this.teamList[i].Value;
        }
      }
    }
  }

  setStreamValidation(Id) {
    var stream = this.HrDetailsForm.get("StreamId");
    const expertiseValue = stream.value;
    if (
      Array.isArray(expertiseValue) &&
      expertiseValue.length === 1 &&
      expertiseValue[0] === ""
    ) {
      stream.setValue(null);
    }
    const isExpertiseEmpty = !expertiseValue || expertiseValue.length === 0;
    if (this.teamList != null) {
      for (var i = 0; i < this.teamList.length; i++) {
        if (this.teamList[i].ID == Id) {
          if (this.teamList[i].Value === "Offshore" && isExpertiseEmpty) {
            stream.setErrors({ required: true });
          } else if (
            this.teamList[i].Value !== "Offshore" &&
            !isExpertiseEmpty
          ) {
            stream.setErrors(null);
          }
          stream.updateValueAndValidity();
          return this.teamList[i].Value;
        }
      }
    }
  }

  setPrimarySkillValidation(Id) {
    var stream = this.HrDetailsForm.get("PrimarySkill");
    const expertiseValue = stream.value;
    if (
      Array.isArray(expertiseValue) &&
      expertiseValue.length === 1 &&
      expertiseValue[0] === ""
    ) {
      stream.setValue(null);
    }
    const isExpertiseEmpty = !expertiseValue || expertiseValue.length === 0;
    if (this.teamList != null) {
      for (var i = 0; i < this.teamList.length; i++) {
        if (this.teamList[i].ID == Id) {
          if (this.teamList[i].Value === "Offshore" && isExpertiseEmpty) {
            stream.setErrors({ required: true });
          } else if (
            this.teamList[i].Value !== "Offshore" &&
            !isExpertiseEmpty
          ) {
            stream.setErrors(null);
          }
          stream.updateValueAndValidity();
          return this.teamList[i].Value;
        }
      }
    }
  }

  getEmployeeTypeValue(Id) {
    if (this.eeTypeList != null) {
      for (var i = 0; i < this.eeTypeList.length; i++) {
        if (this.eeTypeList[i].ID == Id) return this.eeTypeList[i].Value;
      }
    }
  }

  getTeams() {
    this.deptSvc.getMasterGroupByCategory("Team").subscribe((data: any) => {
      this.deptSvc
        .getMasterGroupByGroupID(data[0].ID)
        .subscribe((dataList: any) => {
          this.teamList = dataList;
          this.teamList = this.teamList.filter(
            (team) => team.Value != "Onshore"
          );
        });
    });
  }

  getStreams() {
    this.emp_Svc.getStreams().subscribe((data: any) => {
      this.StreamList = data;
      this.filteredStreams = data;
    });
  }

  getPrimarySkills() {
    this.emp_Svc.getPrimarySkills().subscribe((data: any) => {
      this.PrimarySkillsList = data;
      this.filteredPrimarySkills = data;
    });
  }

  getAdditionalSkills() {
    this.emp_Svc.getSecondarySkills().subscribe((data: any) => {
      this.AdditionalSkillsList = data;
      this.fullDataLoading = false;
    });
  }

  setResignationDate() {
    if (
      this.getTeamValue(this.HREmp.TeamId) == "Onsite" &&
      this.HREmp.ResignationDate == null
    ) {
      this.HREmp.ResignationDate = this.HREmp.DateOfExit;
    }
  }

  //getTeamList(callback: TeamListCallback) {
  //  this.deptSvc.getMasterGroupByCategory("Team").subscribe((data: any) => {
  //    this.deptSvc
  //      .getMasterGroupByGroupID(data[0].ID)
  //      .subscribe((dataList: any[]) => {
  //        this.teamList = dataList;
  //        this.teamList = this.teamList.filter(
  //          (team) => team.Value != "Onshore"
  //        );
  //        callback(this.teamList); // Invoke the callback with teamList
  //      });
  //  });
  //}

  //getEeTypeList(callback: EmpTypeListCallback) {
  //  this.deptSvc.getMasterGroupByCategory("EeType").subscribe((data: any) => {
  //    this.deptSvc
  //      .getMasterGroupByGroupID(data[0].ID)
  //      .subscribe((dataList: any) => {
  //        this.eeTypeList = dataList;
  //        callback(this.eeTypeList);
  //      });
  //  });
  //}

  getEeType() {
    this.deptSvc.getMasterGroupByCategory("EeType").subscribe((data: any) => {
      this.deptSvc
        .getMasterGroupByGroupID(data[0].ID)
        .subscribe((dataList: any) => {
          this.eeTypeList = dataList;
        });
    });
  }
  GetTechGroup() {
    this.deptSvc
      .getMasterGroupByCategory("TechGroup")
      .subscribe((data: any) => {
        this.RequiredTech = true;
        this.techGroupList = data;
        this.filteredTechList = this.techGroupList;
      });
  }

  onSelectedTechGroupId() {
    if (this.HREmp.TechGroupId != null) {
      this.HREmp.StreamId = null;
      this.HREmp.PrimarySkillId = null;
      this.filteredStreams = this.StreamList.filter(stream => stream.TeachGroupId == this.HREmp.TechGroupId)
    }
  }

  onSelectedStream() {
    if (this.HREmp.StreamId != null) {
      this.HREmp.PrimarySkillId = null;
      //this.filteredStreams = this.PrimarySkillsList.filter(skill => skill.TeachGroupId == this.HREmp.TechGroupId && skill.StreamId == this.HREmp.StreamId);
    }
  }


  getDesignations() {
    this.hrSvc.getDesignations().subscribe((data: any) => {
      this.Required = true;
      this.designationsList = data;
      this.filteredList = this.designationsList;
      // if (!isUndefined(this.empCode)) {
      // this.getBasicEmployeeByCode();
      //}
    });
  }
  getLocations() {
    this.hrSvc.getLocations().subscribe((data: any) => {
      this.locationsList = data;
    });
  }
  getDepartments() {
    this.hrSvc.getDepartments().subscribe((data: any) => {
      this.RequiredDept = true;
      this.departmentsList = data;
      this.filteredDeptList = this.departmentsList;
    });
  }
  getCadres() {
    this.hrSvc.getCadres().subscribe((data: any) => {
      this.RequiredCadre = true;
      this.cadresList = data;
      this.filteredCadreList = data;
    });
  }

  //setCadre() {
  //  if (this.HREmp.DivisionId != null) {
  //    var Id = this.HREmp.DivisionId == 36 ? true : false;
  //    this.hrSvc.getCadres().subscribe((data: any) => {
  //      this.cadresList = data;
  //      this.filteredCadreList = this.cadresList.filter(item => item.IsDelivery == Id);
  //    });
  //  }
  //}

  getEmployeeList() {
    /* this.emp_Svc.getAllEmployees().subscribe(*/
    this.emp_Svc.getEmployeeBasicDetails().subscribe(
      (data: any[]) => {
        this.empList = data || [];
        this.tempPMList = [];
        this.empList.forEach((el) => {
          let item = new pmObj();
          item.pmDisplayName = el.FirstName + " - " + el.EmpCode;
          item.pmEmpCode = el.EmpCode;
          this.tempPMList.push(item);
        });
        this.filteredPMList =
          this.tempPMList &&
          this.tempPMList.filter(
            (emp) => emp.pmEmpCode !== (this.HREmp && this.HREmp.EmpCode)
          );

        this.HREmp &&
          this.HREmp.peopleManagersHistoryDetails &&
          this.HREmp.peopleManagersHistoryDetails.forEach((el) => {
            el.pmDisplayName =
              this.tempPMList.filter(
                (x) => x.pmEmpCode === el.ManagerCode
              )[0] != null
                ? this.tempPMList.filter(
                  (x) => x.pmEmpCode === el.ManagerCode
                )[0].pmDisplayName
                : null;
          });
      },
      (error) => (this.error = error)
    );
  }

  setManager(value) {
    if (value.pmDisplayName == null && this.empList != null) {
      this.tempPMList = [];
      this.empList.forEach((el) => {
        let item = new pmObj();
        item.pmDisplayName = el.FirstName + " - " + el.EmpCode;
        item.pmEmpCode = el.EmpCode;
        this.tempPMList.push(item);
      });
      this.filteredPMList = this.tempPMList.filter(
        (emp) => emp.pmEmpCode !== this.HREmp.EmpCode
      );

      this.HREmp.peopleManagersHistoryDetails.forEach((el) => {
        el.pmDisplayName =
          this.tempPMList.filter(
            (x) => x.pmEmpCode === el.ManagerCode
          )[0] != null
            ? this.tempPMList.filter(
              (x) => x.pmEmpCode === el.ManagerCode
            )[0].pmDisplayName
            : null;
      })
      //this.emp_Svc.getEmployeeBasicDetails().subscribe(
      //  (data: any[]) => {
      //    //this.empList = data;
      //    this.tempPMList = [];
      //    this.empList.forEach((el) => {
      //      let item = new pmObj();
      //      item.pmDisplayName = el.FirstName + " - " + el.EmpCode;
      //      item.pmEmpCode = el.EmpCode;
      //      this.tempPMList.push(item);
      //    });
      //    this.filteredPMList = this.tempPMList.filter(
      //      (emp) => emp.pmEmpCode !== this.HREmp.EmpCode
      //    );

      //    this.HREmp.peopleManagersHistoryDetails.forEach((el) => {
      //      el.pmDisplayName =
      //        this.tempPMList.filter(
      //          (x) => x.pmEmpCode === el.ManagerCode
      //        )[0] != null
      //          ? this.tempPMList.filter(
      //              (x) => x.pmEmpCode === el.ManagerCode
      //            )[0].pmDisplayName
      //          : null;
      //    });
      //  },
      //  (error) => (this.error = error)
      //);
    }
  }
  getUserRoles() {
    this.emp_Svc.getUserRoles().subscribe(
      (data: any[]) => {
        this.UserRolesList = data;
      },
      (error) => (this.error = error)
    );
  }
  getEmployeeSMList() {
    this.emp_Svc.getEmployeeBasicDetails().subscribe(
      (data: any[]) => {
        this.tempSMList = [];
        //this.empList = data || [];
        this.empList.forEach((el) => {
          let item = new smObj();
          item.smDisplayName = el.FirstName + " - " + el.EmpCode;
          item.smEmpCode = el.EmpCode;
          this.tempSMList.push(item);
        });
        this.filteredSMList = this.tempSMList.filter(
          (emp) => emp.smEmpCode !== (this.HREmp && this.HREmp.EmpCode)
        );
        this.HREmp &&
          this.HREmp.seniorManagersHistoryDetails.forEach((el) => {
            el.smDisplayName =
              this.tempSMList.filter(
                (x) => x.smEmpCode === el.SeniorManagerCode
              )[0] != null
                ? this.tempSMList.filter(
                  (x) => x.smEmpCode === el.SeniorManagerCode
                )[0].smDisplayName
                : null;
          });
      },
      (error) => (this.error = error)
    );
  }

  setSeniorManager(value) {
    if (value.smDisplayName == null && this.empList != null) {
      this.tempSMList = [];
      this.empList.forEach((el) => {
        let item = new smObj();
        item.smDisplayName = el.FirstName + " - " + el.EmpCode;
        item.smEmpCode = el.EmpCode;
        this.tempSMList.push(item);
      });
      this.filteredSMList = this.tempSMList.filter(
        (emp) => emp.smEmpCode !== this.HREmp.EmpCode
      );
      this.HREmp.seniorManagersHistoryDetails.forEach((el) => {
        el.smDisplayName =
          this.tempSMList.filter(
            (x) => x.smEmpCode === el.SeniorManagerCode
          )[0] != null
            ? this.tempSMList.filter(
              (x) => x.smEmpCode === el.SeniorManagerCode
            )[0].smDisplayName
            : null;
      })
      //this.emp_Svc.getEmployeeBasicDetails().subscribe(
      //  (data: any[]) => {
      //    this.tempSMList = [];
      //    this.empList = data;
      //    this.empList.forEach((el) => {
      //      let item = new smObj();
      //      item.smDisplayName = el.FirstName + " - " + el.EmpCode;
      //      item.smEmpCode = el.EmpCode;
      //      this.tempSMList.push(item);
      //    });
      //    this.filteredSMList = this.tempSMList.filter(
      //      (emp) => emp.smEmpCode !== this.HREmp.EmpCode
      //    );
      //    this.HREmp.seniorManagersHistoryDetails.forEach((el) => {
      //      el.smDisplayName =
      //        this.tempSMList.filter(
      //          (x) => x.smEmpCode === el.SeniorManagerCode
      //        )[0] != null
      //          ? this.tempSMList.filter(
      //              (x) => x.smEmpCode === el.SeniorManagerCode
      //            )[0].smDisplayName
      //          : null;
      //    });
      //  },
      //  (error) => (this.error = error)
      //);
    }
  }

  getRefreshPage() {
    window.location.reload();
  }

  getObjectState() {
    const originalEmp = this.originalHrEmp;
    delete originalEmp.employeeDetails;
    delete originalEmp.profileVerification;
    var currentEmp = this.HREmp;
    delete currentEmp.employeeDetails;
    delete currentEmp.profileVerification;
    originalEmp.ExpertiseId =
      originalEmp.ExpertiseId == "" ? null : originalEmp.ExpertiseId;
    currentEmp.ExpertiseId =
      currentEmp.ExpertiseId == "" ? null : currentEmp.ExpertiseId;
    if (currentEmp.peopleManagersHistoryDetails.length > 0) {
      currentEmp.peopleManagersHistoryDetails.forEach((item) => {
        if (item.hasOwnProperty("pmDisplayName")) {
          delete item.pmDisplayName;
        }
      });
    }

    if (currentEmp.seniorManagersHistoryDetails.length > 0) {
      currentEmp.seniorManagersHistoryDetails.forEach((item) => {
        if (item.hasOwnProperty("smDisplayName")) {
          delete item.smDisplayName;
        }
      });
    }
    return !(JSON.stringify(originalEmp) == JSON.stringify(currentEmp));
  }

  ngOnDestroy(): void {
    this.destroyed = true;
  }

  GetProbation(DOJ, TeamId, EeTypeId) {
    var doj = new Date(DOJ);
    if (DOJ != undefined && DOJ != null) {
      this.deptSvc.fetchAndCacheEeTypeList('Team').subscribe((teamList) => {
        const teamVal = teamList.find((team) => team.ID === TeamId);
        this.deptSvc.fetchAndCacheEeTypeList('EeType').subscribe((eeTypeList) => {
          const eeTypeVal = eeTypeList.find((emp) => emp.ID === EeTypeId);
          let TeamValue = teamVal ? teamVal.Value : null;
          let EeTypeValue = eeTypeVal ? eeTypeVal.Value : null;
          if (TeamValue == "Offshore" && EeTypeValue == "Regular") {
            doj.setMonth(doj.getMonth() + 6);
            this.HREmp.ProbationDate = doj;
          } else if (
            (TeamValue == "Onshore" || TeamValue == "Onsite") &&
            EeTypeValue == "Regular"
          ) {
            doj.setDate(doj.getDate() + 89);
            this.HREmp.ProbationDate = doj;
          } else if (TeamValue == "Offshore" && EeTypeValue == "Trainee") {
            doj.setFullYear(doj.getFullYear() + 1);
            this.HREmp.ProbationDate = doj;
          } else {
            this.HREmp.ProbationDate = null;
          }
          this.HrDetailsForm.get("Probation").setValue(this.HREmp.ProbationDate);

          this.fullDataLoading = false;
          if (!this.destroyed) this.cdr.detectChanges();
        });
      });
    }
  }

  sendBasicDetails() {
    if (!this.destroyed) this.cdr.detectChanges();
    return this.HREmp;
  }

  getBasicEmployeeByCode() {
    this.isSaved = this.empCode == null ? false : true;

    if (this.empCode != null) {
      this.emp_Svc.getBasicEmployeeById(this.empCode).subscribe(
        (data: any) => {
          this.HrDetailsForm.get("EmployeeCode").disable();
          this.HrDetailsForm.get("OfficeMailId").disable();
          this.HREmp = data;

          this.HREmp.ResumeLastUpdated = formatDate(this.HREmp.ResumeLastUpdated, 'dd-MMM-yyyy HH:mm:ss', 'en-US')

          this.HREmp.DOJ = this.HREmp.DOJ != null ? new Date(this.HREmp.DOJ) : this.HREmp.DOJ
          if (this.HREmp.ProbationDate == null) {
            this.GetProbation(
              this.HREmp && this.HREmp.DOJ,
              this.HREmp && this.HREmp.TeamId,
              this.HREmp && this.HREmp.EeTypeId
            );
          }
          if (
            (this.HREmp && this.HREmp.LocationID == 1) ||
            (this.HREmp && this.HREmp.LocationID == 2)
          ) {
            this.disableDOE = true;
          } else this.disableDOE = false;
          if (this.HREmp && this.HREmp.CelebratedDOB === null) {
            this.HREmp.CelebratedDOB = this.HREmp.DOB;
          }

          if (
            this.HREmp &&
            this.HREmp.LocationID != null &&
            (this.HREmp.LocationID === 1 || this.HREmp.LocationID === 2) &&
            this.HREmp.JobLocationState == null
          ) {
            this.setJobLocationState();
          }
          if (
            this.HREmp &&
            this.HREmp.IsMigratedOnH1 &&
            this.HREmp &&
            this.HREmp.DateOfExit
          ) {
            this.setUSDOJ(this.HREmp.DateOfExit);
          }
          var seniorManager = new SeniorManagersHistoryDetails();
          this.setTeam(this.HREmp && this.HREmp.LocationID);
          if (this.HREmp) {
            this.HREmp.seniorManagersHistoryDetails =
              this.HREmp.seniorManagersHistoryDetails.slice(0, 1) || [];
          }
          if (
            this.HREmp &&
            this.HREmp.seniorManagersHistoryDetails.length == 0
          ) {
            this.newAttribute = {
              ID: 0,
              DurationFrom: "",
              DurationTo: "",
              Name: "",
              Designation: "",
            };
            this.HREmp.seniorManagersHistoryDetails.push(this.newAttribute);
            this.newAttribute = {};
          }
          var peopleManager = new PeopleManagersHistoryDetails();

          //this.HREmp.peopleManagersHistoryDetails.sort((a, b) => {
          //  const dateA = new Date(a.DurationTo);
          //  const dateB = new Date(b.DurationTo);
          //  return dateB.getTime() - dateA.getTime();
          //});
          if (this.HREmp) {
            this.HREmp.peopleManagersHistoryDetails =
              this.HREmp.peopleManagersHistoryDetails.slice(0, 1);
          }
          if (
            this.HREmp &&
            this.HREmp.peopleManagersHistoryDetails.length == 0
          ) {
            this.newAttributepm = {
              ID: 0,
              DurationFrom: "",
              DurationTo: "",
              Name: "",
              Designation: "",
            };
            this.HREmp.peopleManagersHistoryDetails.push(this.newAttributepm);
            this.newAttributepm = {};
          }
          this.getEmployeeSMList();
          this.getEmployeeList();
          this.enableJoblocationState =
            this.isSaved && this.HREmp && this.HREmp.JobLocationState != null
              ? false
              : true;
          this.enableLocation =
            this.isSaved && this.HREmp && this.HREmp.LocationID != null
              ? false
              : true;
          this.enableDesignation =
            this.isSaved && this.HREmp && this.HREmp.DesignationId != null
              ? false
              : true;
          this.cdr.detectChanges();
          this.enableCadre =
            this.isSaved && this.HREmp && this.HREmp.CadreId != null
              ? false
              : true;
          this.cdr.detectChanges();
          this.enableDepartment =
            this.isSaved && this.HREmp && this.HREmp.DepartmentId != null
              ? false
              : true;
          this.cdr.detectChanges();
          this.enableDivision =
            this.isSaved && this.HREmp && this.HREmp.DivisionId != null
              ? false
              : true;
          this.enableSeniorManager =
            this.isSaved &&
              this.HREmp &&
              this.HREmp.seniorManagersHistoryDetails[0].ID > 0
              ? false
              : true;
          this.enablePeopleManager =
            this.isSaved &&
              this.HREmp &&
              this.HREmp.peopleManagersHistoryDetails[0].ID > 0
              ? false
              : true;
          this.cdr.detectChanges();
          if (this.designationsList != null && this.designationsList.length > 0) {
            this.designationsList.forEach((item) => {
              if (item.ID == (this.HREmp && this.HREmp.DesignationId)) {
                this.designationId = item.DesignationName;
              }
            });
          }
          if (this.departmentsList != null && this.departmentsList.length > 0) {
            this.departmentsList.forEach((item) => {
              if (item.ID == (this.HREmp && this.HREmp.DepartmentId)) {
                this.departmentId = item.DepartmentName;
                this.enableExpertise =
                  this.isSaved &&
                    this.departmentId == "Delivery" &&
                    this.HREmp.ExpertiseId != "" &&
                    this.HREmp.ExpertiseId != null
                    ? false
                    : true;
                this.enableTechgroup =
                  this.isSaved &&
                    this.departmentId == "Delivery" &&
                    this.HREmp.TechGroupId != null
                    ? false
                    : true;
              }
            });
          }
          if (this.cadresList != null && this.cadresList.length > 0) {
            this.cadresList.forEach((item) => {
              if (item.ID == (this.HREmp && this.HREmp.CadreId)) {
                this.cadreId = item.CadreName;
              }
              this.cdr.detectChanges();
            });
            this.cdr.detectChanges();
          }
          if (this.techGroupList != null && this.techGroupList.length > 0) {
            this.techGroupList.forEach((item) => {
              if (item.ID == (this.HREmp && this.HREmp.TechGroupId)) {
                this.TechGroupId = item.GroupName;
              }
            });
          }
          const usdoj = this.HrDetailsForm.get("US_DOJ");
          const usdoe = this.HrDetailsForm.get("US_DOE");
          const oldloc = this.HrDetailsForm.get("OldLocation");
          if (this.HREmp.IsMigratedOnH1 === true && !this.isProfile) {
            usdoj.setValidators([Validators.required]);
            oldloc.setValidators([Validators.required]);
          } else {
            usdoj.clearValidators();
            usdoe.clearValidators();
            oldloc.clearValidators();
          }
          usdoj.updateValueAndValidity();
          usdoe.updateValueAndValidity();
          oldloc.updateValueAndValidity();
          this.getCommunicationData()
          this.onSelectedTechGroupId();

          this.HREmp.ExpertiseId = data.ExpertiseId.split(",");
          this.originalHrEmp = JSON.parse(JSON.stringify(this.HREmp));
          this.HrEmpOutput.emit(this.HREmp);
        },
        (error) => (this.error = error)
      );
    } else {
      var seniorManager = new SeniorManagersHistoryDetails();

      this.HREmp.seniorManagersHistoryDetails =
        this.HREmp.seniorManagersHistoryDetails.slice(0, 1);
      if (this.HREmp.seniorManagersHistoryDetails.length == 0) {
        this.newAttribute = {
          ID: 0,
          DurationFrom: "",
          DurationTo: "",
          Name: "",
          Designation: "",
        };
        this.HREmp.seniorManagersHistoryDetails.push(this.newAttribute);
        this.newAttribute = {};
      }
      var peopleManager = new PeopleManagersHistoryDetails();

      //this.HREmp.peopleManagersHistoryDetails.sort((a, b) => {
      //  const dateA = new Date(a.DurationTo);
      //  const dateB = new Date(b.DurationTo);
      //  return dateB.getTime() - dateA.getTime();
      //});

      this.HREmp.peopleManagersHistoryDetails =
        this.HREmp.peopleManagersHistoryDetails.slice(0, 1);

      if (this.HREmp.peopleManagersHistoryDetails.length == 0) {
        this.newAttributepm = {
          ID: 0,
          DurationFrom: "",
          DurationTo: "",
          Name: "",
          Designation: "",
        };
        this.HREmp.peopleManagersHistoryDetails.push(this.newAttributepm);
        this.newAttributepm = {};
      }
      this.getEmployeeSMList();
      this.getEmployeeList();
    }
  }

  setUSDOJ(value) {
    if (value != null) {
      const parsedDate = new Date(value);
      this.HREmp.US_DOJ = new Date(parsedDate.getTime() + 24 * 60 * 60 * 1000);
      this.HrDetailsForm.get("US_DOJ").setValue(this.HREmp.US_DOJ);
    }
  }

  profileFields() {
    this.EmpDetform.get("AadharFile").setValue(null);
    this.EmpDetform.get("PanFile").setValue(null);
    this.HrDetailsForm.get("ResumeFile").setValue(null);
    if (this.isProfile) {
      this.HrDetailsForm.disable();
      this.HrDetailsForm.get('SecondaryEmail').enable();
      this.HrDetailsForm.get("BloodGroup").enable();
      this.HrDetailsForm.get("MobileNo").enable();
      this.HrDetailsForm.get("WhatsappNo").enable();
      this.HrDetailsForm.get("LinkedInID").enable();
      this.HrDetailsForm.get("ResumeFile").enable();
      if (this.employeeDetails.PAN) {
        this.EmpDetform.get("PAN").disable();
      }

      if (
        this.employeeDetails.Aadhar != null &&
        this.employeeDetails.Aadhar != ""
      ) {
        this.EmpDetform.get("Aadhar").disable();
      }

      //if (
      //  this.employeeDetails.PanFilePath != null &&
      //  this.employeeDetails.PanFilePath != ""
      //) {
      //  this.EmpDetform.get("PanFile").disable();
      //}
      //if (
      //  this.employeeDetails.AadharFilePath != null &&
      //  this.employeeDetails.AadharFilePath != ""
      //) {
      //  this.EmpDetform.get("AadharFile").disable();
      //}
      //if (this.employeeDetails.AadharFilePath != null && this.employeeDetails.AadharFilePath != '') {
      //  this.EmpDetform.get('AadharFile').disable();
      //}
      //this.HrDetailsForm.get('FirstName').disable();
      //this.HrDetailsForm.get('LastName').disable();
      //this.HrDetailsForm.get('MiddleName').disable();
      //this.HrDetailsForm.get('MobileNo').disable();
      //this.HrDetailsForm.get('DOJ').disable();
      //this.HrDetailsForm.get('DateOfExit').disable();
      //this.HrDetailsForm.get('DOB').disable();
      //this.HrDetailsForm.get('Designation').disable();
      //this.HrDetailsForm.get('ConsultantType').disable();
      //this.HrDetailsForm.get('Department').disable();
      //this.HrDetailsForm.get('Cadre').disable();
      //this.HrDetailsForm.get('EeTypeId').disable();
      //this.HrDetailsForm.get('TeamId').disable();
      //this.HrDetailsForm.get('Location').disable();
      //this.HrDetailsForm.get('TimeZone').disable();
      //this.HrDetailsForm.get('NamePerRecords').disable();
      //this.HrDetailsForm.get('TechGroupId').disable();
      //this.HrDetailsForm.get('ExpertiseId').disable();
      //this.HrDetailsForm.get('Gender').disable();
      //this.HrDetailsForm.get('MCPId').disable();
    }
    else {
      //this.HrDetailsForm.get('OfficeMailId').enable();
    }
  }

  getFileName(type) {
    if (type == 'aadhar')
      return this.HREmp.EmpCode + "_" + this.HREmp.NamePerRecords + "_Aadhar";
    else
      return this.HREmp.EmpCode + "_" + this.HREmp.NamePerRecords + "_Pan";
  }

  handleFile(event, n) {
    if (event.target.files == undefined) {
      if (n == 0) {
        this.employeeDetails.Aadharfile = null;
      } else if (n == 1) {
        this.employeeDetails.Panfile = null;
      }
    }
    const files: FileList = event.target.files;
    if (files && files.length > 0) {
      if (!this.validFileType(files[0])) {
        this.toastr.warning(
          "File name " + files[0].name + ": Not a valid file type."
        );
        // Clear the input
        event.srcElement.value = null;
        event.currentTarget.value = null;
      }
      // Don't allow file sizes over 1MB
      if (files[0].size < this.MAX_SIZE) {
        if (n == 0) {
          this.employeeDetails.Aadharfile =
            this.file_Svc.readAndUploadFile(files);
          this.employeeDetails.AadharFilePath = null;
        } else if (n == 1) {
          this.employeeDetails.Panfile = this.file_Svc.readAndUploadFile(files);
          this.employeeDetails.PanFilePath = null;
        }
      } else {
        this.toastr.warning(
          " File: " +
          files[0].name +
          " exceeds 1MB hence it cannot be uploaded."
        );
        // Clear the input
        event.srcElement.value = null;
        event.currentTarget.value = null;
        // this.EmpDetform.controls.AadharFile.setValue("");
      }
    }
  }

  validFileType(file) {
    let types = File_Types;
    return types.includes(file.type);
  }

  getAadharPanDetails() {
    return this.EmpDetform.value;
  }

  ngDoCheck() {
    if (this.employeeDetails != null && this.employeeDetails.AadharFilePath) {
      this.EmpDetform.controls["AadharFile"].clearValidators();
      this.EmpDetform.controls["AadharFile"].setErrors(null);
      this.EmpDetform.controls["PanFile"].clearValidators();
      this.EmpDetform.controls["PanFile"].setErrors(null);
    } else if (this.getTeamValue(this.HREmp.TeamId) == 'Offshore') {
      if (this.employeeDetails.AadharFilePath == null || this.employeeDetails.AadharFilePath == '') {
        this.EmpDetform.controls["AadharFile"].setValidators([
          Validators.required,
        ]);
      }
      if (this.HREmp.ConsultantType !== "FTE") {
        this.EmpDetform.controls["PanFile"].clearValidators();
        this.EmpDetform.controls["PanFile"].setErrors(null);
      }

    }
    else if (this.getTeamValue(this.HREmp.TeamId) == 'Onsite') {
      this.EmpDetform.controls["AadharFile"].clearValidators();
      this.EmpDetform.controls["AadharFile"].setErrors(null);
      this.EmpDetform.controls["PanFile"].clearValidators();
      this.EmpDetform.controls["PanFile"].setErrors(null);
    }
  }

  FormInitialization() {
    this.EmpDetform = new FormGroup({
      PAN: new FormControl(),
      Aadhar: new FormControl(),
      PanFile: new FormControl(),
      AadharFile: new FormControl(),
    });
    this.HrDetailsForm = new FormGroup({
      EmployeeCode: new FormControl(),
      OfficeMailId: new FormControl("", [
        Validators.required,
        Validators.pattern(
          "[a-zA-Z0-9!#$%&amp;'*+/=?^_`{|}~.-]+@[winwire]+(.[com]+)*"
        ),
      ]),
      SecondaryEmail: new FormControl("", [
        Validators.email,
        this.emailDomain,
        Validators.pattern(
          "[a-zA-Z0-9!#$%&amp;'*+/=?^_`{|}~.-]+@[a-zA-Z]+(.[a-z]+)*"
        ),
      ]),
      DOJ: new FormControl(),
      LinkedInID: new FormControl(),
      Probation: new FormControl(),
      DateOfExit: new FormControl(),
      MigratedonH1: new FormControl(),
      US_DOJ: new FormControl(),
      US_DOE: new FormControl(),
      ResignationDate: new FormControl(),
      OldLocation: new FormControl(),
      EmpStatus: new FormControl(),
      MobileNo: new FormControl(),
      WhatsappNo: new FormControl(),
      FirstName: new FormControl(),
      LastName: new FormControl(),
      MiddleName: new FormControl(),
      NamePerRecords: new FormControl(),
      DOB: new FormControl(),
      CelebratedDOB: new FormControl(),
      Gender: new FormControl(),
      BloodGroup: new FormControl(),
      Designation: new FormControl("", [
        Validators.required,
        this.requireMatch.bind(this),
      ]),
      GroupId: new FormControl(),
      Type: new FormControl(),
      Location: new FormControl(),
      JobLocationState: new FormControl(),
      WorkPlace: new FormControl(),
      ConsultantType: new FormControl(),
      HiringType: new FormControl(),
      FiveCStatus: new FormControl(),
      EmpSubType: new FormControl(),
      PeopleManager: new FormControl(null, [
        Validators.required,
        this.requireMatchPM.bind(this),
      ]),
      SeniorManager: new FormControl(null, [this.requireMatchSM.bind(this)]),
      DivisionId: new FormControl(),
      Cadre: new FormControl("", [
        Validators.required,
        this.requireMatchCadre.bind(this),
      ]),
      EeTypeId: new FormControl(),
      TeamId: new FormControl(),
      TimeZone: new FormControl(),
      MCPId: new FormControl(),
      IsDeceased: new FormControl(),
      GMCInclusion: new FormControl(),
      GPAInclusion: new FormControl(),
      TechGroupId: new FormControl(), //'', [Validators.required]),
      StreamId: new FormControl(), //'', [Validators.required]),
      PrimarySkill: new FormControl(),
      SecondarySkill: new FormControl(),
      Department: new FormControl("", [
        Validators.required,
        this.requireMatchDept.bind(this),
      ]),
      Title: new FormControl(),
      ResumeFile: new FormControl(),
      additionalSkills: this.additionalSkills
    });
  }
  booleanOptions = [
    { value: true, label: "Yes" },
    { value: false, label: "No" },
  ];
  ChangeDesignation() {
    const message = `Add New Designation`;
    const dialogData = new DesignationDialog("Action", message);
    const dialogRef = this.dialog.open(DesignationDialogComponent, {
      width: "400px",
      data: dialogData,
    });
    dialogRef.afterClosed().subscribe(
      (dialogResult) => {
        if (dialogResult) {
          this.getDesignations();
          this.filteredList.filter((x) => x.Id == dialogResult.DesignationName);
          this.designationId = "";
          this.Required = false;
        }
      },
      (error) => {
        this.error = error;
      }
    );
  }
  ChangeDepartment() {
    const message = `Add New Department`;
    const dialogData = new DepartmentDialog("Action", message);
    const dialogRef = this.dialog.open(DepartmentDialogComponent, {
      width: "400px",
      data: dialogData,
    });
    dialogRef.afterClosed().subscribe(
      (dialogResult) => {
        if (dialogResult) {
          this.getDepartments();
          this.filteredDeptList.filter(
            (x) => x.Id == dialogResult.DepartmentName
          );
          this.departmentId = "";
          this.RequiredDept = false;
        }
      },
      (error) => {
        this.error = error;
      }
    );
  }

  setEmployeeStatus(event: any): void {
    if (event.value == true) {
      this.HREmp.EmpStatus = "Deceased";
      this.HrDetailsForm.get("EmpStatus").setValue(this.HREmp.EmpStatus);
      this.cdr.detectChanges();
    } else {
      this.setEmpStatus();
    }
  }

  IsMigratedChange(event: any): void {
    this.HREmp.IsMigratedOnH1 = event.value;
    if (event.value === false) {
      this.HREmp.US_DOJ = null;
      this.HREmp.US_DOE = null;
      this.HREmp.OldIndLocationID = null;
      this.HrDetailsForm.get("US_DOJ").setValue(null);
      this.HrDetailsForm.get("US_DOE").setValue(null);
      this.HrDetailsForm.get("OldLocation").setValue(null);
    } else if (event.value === true) {
      this.HrDetailsForm.get("TeamId").setValue(null);
      this.HREmp.TeamId = null;
      this.HrDetailsForm.get("Location").setValue(null);
      this.HREmp.LocationID = null;
      this.HrDetailsForm.get("JobLocationState").setValue(null);
      this.HREmp.JobLocationState = null;
      this.enableLocation = true;
      this.enableJoblocationState = true;
    }
    const usdoj = this.HrDetailsForm.get("US_DOJ");
    const usdoe = this.HrDetailsForm.get("US_DOE");
    const oldloc = this.HrDetailsForm.get("OldLocation");
    if (event.value === true && !this.isProfile) {
      usdoj.setValidators([Validators.required]);
      oldloc.setValidators([Validators.required]);
    } else {
      usdoj.clearValidators();
      usdoe.clearValidators();
      oldloc.clearValidators();
    }

    usdoj.updateValueAndValidity();
    usdoe.updateValueAndValidity();
    oldloc.updateValueAndValidity();
    this.cdr.detectChanges();
  }

  getOfficeViewerUrl(docUrl: string): string {
    return `https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(
      docUrl
    )}`;
  }

  MigratedonH1() {
    if (this.HREmp.TeamId != 32) {
      this.HREmp.IsMigratedOnH1 = null;
      this.HREmp.US_DOJ = null;
      this.HREmp.US_DOE = null;
      this.HREmp.OldIndLocationID = null;
      this.HrDetailsForm.get("US_DOJ").setValue(null);
      this.HrDetailsForm.get("US_DOE").setValue(null);
      this.HrDetailsForm.get("OldLocation").setValue(null);
      this.cdr.detectChanges();
    }
  }

  getJobLocationState(locationID: number) {
    switch (locationID) {
      case 1:
        return "Telangana";
      case 2:
        return "Karnataka";
      default:
        return null;
    }
  }

  ChangeCadre() {
    const message = `Add New Cadre`;
    const dialogData = new CadreDialog("Action", message);
    const dialogRef = this.dialog.open(CadreDialogComponent, {
      width: "400px",
      data: dialogData,
    });
    dialogRef.afterClosed().subscribe(
      (dialogResult) => {
        if (dialogResult) {
          this.getCadres();
          this.filteredCadreList.filter((x) => x.Id == dialogResult.CadreName);
          this.cadreId = "";
          this.RequiredCadre = false;
        }
      },
      (error) => {
        this.error = error;
      }
    );
  }

  setDOB() {
    this.minDate = null;
    if (this.HREmp.DOJ != null) {
      var dob = new Date(this.HREmp.DOJ);
      dob.setFullYear(dob.getFullYear() - 18);
      this.maxDate = dob;
    }
    return null;
  }

  setTeam(value) {
    setTimeout(() => {
      if (value != null || value != "") {
        this.deptSvc.fetchAndCacheEeTypeList('Team').subscribe((teamList) => {
          this.hrSvc.getLocations().subscribe((data: any) => {
            this.locationsList = data;
            var location = this.locationsList.filter((loc) => loc.ID == value);
            if (location.length > 0) {
              if (
                location[0].LocationName === "Hyderabad" ||
                location[0].LocationName === "Bengaluru"
              ) {
                this.filteredTeamList = teamList.filter(
                  (team) => team.Value == "Offshore"
                );
                this.HrDetailsForm.get("TeamId").setValue(
                  this.filteredTeamList[0].ID
                );
                this.HREmp.TeamId = this.filteredTeamList[0].ID;
              }
              if (
                location[0].LocationName !== "Hyderabad" &&
                location[0].LocationName !== "Bengaluru"
              ) {
                this.filteredTeamList = teamList.filter(
                  (team) => team.Value == "Onsite"
                );
                this.HrDetailsForm.get("TeamId").setValue(
                  this.filteredTeamList[0].ID
                );
                this.HREmp.TeamId = this.filteredTeamList[0].ID;
              }
            }
          });
        });
      }
      if (
        (this.originalHrEmp && this.originalHrEmp.TeamId) !=
        (this.HREmp && this.HREmp.TeamId)
      )
        this.GetProbation(this.HREmp.DOJ, this.HREmp.TeamId, this.HREmp.EeTypeId);
      this.resetEmpSubType();
    });
    if (!this.destroyed) this.cdr.detectChanges();
  }

  setEmpStatus() {
    var value = this.HREmp.IsMigratedOnH1
      ? this.HREmp.US_DOE
      : this.HREmp.DateOfExit;
    if (this.HREmp.IsDeceased != true) {
      if (value == null) {
        this.HREmp.EmpStatus = "Active";
      } else if (
        value != null &&
        formatDate(value, "yyyy-MM-dd", "en_US") >=
        formatDate(new Date(), "yyyy-MM-dd", "en_US")
      ) {
        this.HREmp.EmpStatus = "Resigned";
        this.HREmp.IsDeceased = false;
        this.HrDetailsForm.get("IsDeceased").setValue(this.HREmp.IsDeceased);
      } else {
        this.HREmp.EmpStatus = "Relieved";
        this.HREmp.IsDeceased = false;
        this.HrDetailsForm.get("IsDeceased").setValue(this.HREmp.IsDeceased);
      }
    } else if (this.HREmp.IsDeceased) {
      this.HREmp.EmpStatus = "Deceased";
    }
    this.HrDetailsForm.get("EmpStatus").setValue(this.HREmp.EmpStatus);
    this.cdr.detectChanges();
  }

  setJobLocation(value) {
    setTimeout(() => {
      this.deptSvc.fetchAndCacheEeTypeList('Team').subscribe((teamList) => {
        const teamVal = teamList.find((team) => team.ID === value);
        this.hrSvc.getLocations().subscribe((data: any) => {
          this.locationsList = data;
          //if (teamVal != null && teamVal.Value === 'Offshore') {
          //  this.filteredLocationsList = this.locationsList.filter(item =>
          //    item.LocationName === 'Hyderabad' || item.LocationName === 'Bengaluru'
          //  );
          //} else if (teamVal != null) {
          //  this.filteredLocationsList = this.locationsList.filter(item =>
          //    item.LocationName !== 'Hyderabad' && item.LocationName !== 'Bengaluru'
          //  );
          //}
          //if (teamVal != null && this.HREmp.LocationID != null && !this.filteredLocationsList.some(item => item.ID === this.HREmp.LocationID)) {
          //  this.HREmp.LocationID = null;
          //  this.HREmp.JobLocationState = null;
          //  this.HrDetailsForm.get('Location').setValue(null);
          //  this.HrDetailsForm.get('JobLocationState').setValue(null);
          //  this.enableLocation = true;
          //  this.enableJoblocationState = true;
          //}
          //if (value === "" && this.originalHrEmp.TeamId != null) {
          //  this.HREmp.LocationID = null;
          //  this.HREmp.JobLocationState = null;
          //  this.HrDetailsForm.get('Location').setValue(null);
          //  this.HrDetailsForm.get('JobLocationState').setValue(null);
          //  this.enableLocation = true;
          //  this.enableJoblocationState = true;
          //}
        });
      });
    });
  }

  showFileInput(resume) {
    if (!this.fileInputVisible) {
      this.fileInputVisible = true;
      resume.open();
    }
  }

  openFileDialog(inputRef: any, fileType: string): void {
    if (!this.fileInputState[fileType]) {
      this.fileInputState[fileType] = true;
      inputRef.open();
    }
  }

  setJobLocationState() {
    if (
      this.HREmp.LocationID != null &&
      (this.HREmp.LocationID === 1 || this.HREmp.LocationID === 2)
    ) {
      this.HREmp.JobLocationState =
        this.HREmp.LocationID == 1 ? "Telangana" : "Karnataka";
      this.HrDetailsForm.get("JobLocationState").setValue(
        this.HREmp.JobLocationState
      );
    } else if (
      this.HREmp.LocationID != null &&
      this.HREmp.LocationID !== 1 &&
      this.HREmp.LocationID !== 2
    ) {
      this.HREmp.JobLocationState = null;
      this.HREmp.JobLocationState == "Telangana" ||
        this.HREmp.JobLocationState == "Karnataka"
        ? this.HrDetailsForm.get("JobLocationState").setValue(null)
        : "";
      this.enableJoblocationState =
        this.HREmp.JobLocationState == "Telangana" ||
          this.HREmp.JobLocationState == "Karnataka"
          ? true
          : false;
    }
  }

  setEmployeeType() {
    setTimeout(() => {
      this.deptSvc.fetchAndCacheEeTypeList('EeType').subscribe((eeTypeList) => {
        if (
          this.HREmp.ConsultantType != null &&
          this.HREmp.ConsultantType === "FTE"
        ) {
          this.filteredeeTypeList = eeTypeList.filter(
            (item) => item.Value === "Regular" || item.Value === "Trainee"
          );
        } else if (
          this.HREmp.ConsultantType != null &&
          this.HREmp.ConsultantType === "SubCon"
        ) {
          this.filteredeeTypeList = eeTypeList.filter(
            (item) =>
              item.Value !== "Regular" &&
              item.Value !== "Trainee" &&
              item.Value != "Others"
          );
          var Id =
            this.filteredeeTypeList.length > 0 &&
              this.filteredeeTypeList.filter((item) => item.Value == "Subcon")
                .length > 0
              ? this.filteredeeTypeList.filter(
                (item) => item.Value == "Subcon"
              )[0].ID
              : null;
          if (Id != null) {
            this.HrDetailsForm.get("EeTypeId").setValue(Id);
            this.HREmp.EeTypeId = Id;
          }
        }
        if (
          this.HREmp.ConsultantType != null &&
          this.HREmp.EeTypeId != null &&
          this.filteredeeTypeList != null &&
          !this.filteredeeTypeList.some(
            (item) => item.ID === this.HREmp.EeTypeId
          )
        ) {
          this.HREmp.EeTypeId = null;
          this.HrDetailsForm.get("EeTypeId").setValue(null);
        }
      });
      if (!this.destroyed) this.cdr.detectChanges();
    });
  }

  getCommunicationData() {
    if (this.empCode != null) {
      this.emp_Svc.getEmployeeDetails(this.empCode).subscribe(
        (data: any) => {
          this.employeeDetails = data;
          this.profileFields();
          this.employeeDet.emit(this.employeeDetails);
        },
        (error) => (this.error = error)
      );
    }
  }

  getCommunicationDataByGroupId(groupId) {
    if (groupId != null) {
      this.emp_Svc.getHREmployeeGroupDetails(groupId).subscribe(
        (data: any) => {
          this.employeeDetails = data;
          this.employeeDet.emit(this.employeeDetails);
        },
        (error) => (this.error = error)
      );
    }
  }
  emptydate() {
    this.HrDetailsForm.get("DateOfExit").reset();
  }

  emptyGMCInclusion() {
    this.HrDetailsForm.get("GMCInclusion").reset();
  }

  emptyGPAInclusion() {
    this.HrDetailsForm.get("GPAInclusion").reset();
  }

  emptyTodate(index) {
    //this.HrDetailsForm.get('DurationTo').reset();
    this.HREmp.peopleManagersHistoryDetails[index].DurationTo = null;
  }
  ChangeTechGroup() {
    const message = `Add New Tech Group`;
    const dialogDataTech = new TechGroupDialog("Action", message);
    const dialogRefTech = this.dialog.open(TechgroupDialogComponent, {
      width: "400px",
      data: dialogDataTech,
    });
    dialogRefTech.afterClosed().subscribe(
      (dialogResultTech) => {
        if (dialogResultTech) {
          this.GetTechGroup();
          this.TechGroupId = dialogResultTech.GroupName;
          this.RequiredTech = false;
        }
      },
      (error) => {
        this.error = error;
      }
    );
  }

  doFilter() {
    if (!isNullOrUndefined(this.designationId)) {
      this.filteredList = this.filter(this.designationsList);
    }
  }
  doFilterCadre() {
    if (!isNullOrUndefined(this.cadreId)) {
      this.filteredCadreList = this.filterCadre(this.cadresList);
    }
  }
  doFilterDept() {
    var techgrp = this.HrDetailsForm.get("TechGroupId");
    var expertise = this.HrDetailsForm.get("ExpertiseId");
    if (!isNullOrUndefined(this.departmentId)) {
      this.filteredDeptList = this.filterDept(this.departmentsList);
    }
    //if (!isNullOrUndefined(this.departmentId) && this.departmentId != 'Delivery') {
    //  this.TechGroupId = null;
    //  this.HREmp.ExpertiseId = null;
    //  this.HrDetailsForm.get('TechGroupId').setValue(null);
    //  this.HrDetailsForm.get('ExpertiseId').setValue(null);
    //  this.enableExpertise = true;
    //  this.enableTechgroup = true;
    //}
    //if (!isNullOrUndefined(this.departmentId) && this.departmentId == 'Delivery' && !this.isProfile) {
    //  techgrp.setValidators([Validators.required]);
    //  expertise.setValidators([Validators.required]);
    //} else {
    //  techgrp.clearValidators();
    //  expertise.clearValidators();
    //  techgrp.updateValueAndValidity();
    //  expertise.updateValueAndValidity();
    //}
  }
  doFilterTech() {
    if (!isNullOrUndefined(this.TechGroupId)) {
      this.filteredTechList = this.filterTech(this.techGroupList);
      this.filteredStreams = this.StreamList.filter(stream => stream.TeachGroupId == this.HREmp.TechGroupId);
    }
  }

  doFilterStream() {
    if (!isNullOrUndefined(this.StreamId)) {
      this.filteredStreams = this.filterTech(this.StreamList);
      //this.filteredPrimarySkills = this.PrimarySkillsList.filter(skill => skill.TeachGroupId == this.HREmp.TechGroupId && skill.StreamId == this.HREmp.StreamId);
    }
  }
  doPMFilter(pm) {
    if (!isNullOrUndefined(pm)) {
      this.filteredPMList = this.filterPM(this.tempPMList, pm).filter(
        (emp) => emp.pmEmpCode !== this.HREmp.EmpCode
      );
    }
  }
  doSMFilter(sm) {
    if (!isNullOrUndefined(sm)) {
      this.filteredSMList = this.filterSM(this.tempSMList, sm).filter(
        (emp) => emp.smEmpCode !== this.HREmp.EmpCode
      );
    }
  }
  equals(objOne, objTwo) {
    if (typeof objOne !== "undefined" && typeof objTwo !== "undefined") {
      return objOne.id === objTwo.id;
    }
  }
  changeClient(data) {
    alert("selected --->" + data);
  }
  //onExp(event) {
  //  if (event.option.value == "") {
  //    this.ChangeExpertise();
  //  } else {
  //    this.HREmp.ExpertiseId = event.option.id;
  //    this.onSelectedTechGroupId();
  //  }
  //}
  //addExp() {
  //  this.ChangeExpertise();
  //}
  onTech(event) {
    if (event.option.value == "") {
      this.ChangeTechGroup();
    } else {
      this.HREmp.TechGroupId = event.option.id;
      this.onSelectedTechGroupId();
    }
  }
  onDept(event) {
    if (event == "Delivery") {
      this.astricbool = true;
    } else {
      this.astricbool = false;
    }
  }
  onSelectionChanged(event) {
    if (event.option.value == "") {
      this.ChangeDesignation();
    } else {
      this.HREmp.DesignationId = event.option.id;
    }
  }
  onDeptSelectionChanged(event) {
    if (event.option.value == "") {
      this.ChangeDepartment();
    } else {
      this.HREmp.DepartmentId = event.option.id;
    }
  }
  onCadreSelectionChanged(event) {
    if (event.option.value == "") {
      this.ChangeCadre();
    } else {
      this.HREmp.CadreId = event.option.id;
    }
  }
  filter(values) {
    return values.filter((value) =>
      value.DesignationName.toLowerCase().includes(
        this.designationId.toLowerCase()
      )
    );
  }
  filterDept(values) {
    return values.filter((value) =>
      value.DepartmentName.toLowerCase().includes(
        this.departmentId.toLowerCase()
      )
    );
  }
  filterCadre(values) {
    return values.filter((value) =>
      value.CadreName.toLowerCase().includes(this.cadreId.toLowerCase())
    );
  }
  filterTech(values) {
    return values.filter((value) =>
      value.GroupName.toLowerCase().includes(this.TechGroupId.toLowerCase())
    );
  }
  filterExp(values) {
    return values.filter((value) =>
      value.Value.toLowerCase().includes(this.expertiseId.toLowerCase())
    );
  }

  filterStream(values) {
    return values.filter((value) =>
      value.Value.toLowerCase().includes(this.StreamId.toLowerCase())
    );
  }
  filterPM(values, pm) {
    return values.filter(
      (value) =>
        value != null &&
        value.pmDisplayName != null &&
        pm != null &&
        value.pmDisplayName.toLowerCase().includes(pm.toString().toLowerCase())
    );
  }
  filterSM(values, sm) {
    return values.filter((value) =>
      value.smDisplayName.toLowerCase().includes(sm.toLowerCase())
    );
  }

  IsPageSaved(value) {
    this.isSaved = value;
    this.cdr.detectChanges();
  }
  //Custom validation for Designation(Mat autocomplete) to validate user text with designations list
  //Returns true if user text is not found in designation list
  private requireMatch(control: FormControl): ValidationErrors | null {
    const selection: any = control.value;
    let match = null;
    if (!isNullOrUndefined(selection) && selection != "") {
      if (this.Required == true) {
        if (!isNullOrUndefined(this.designationsList)) {
          for (var i = 0; i < this.designationsList.length; i++) {
            if (this.designationsList[i].DesignationName == selection) {
              match = null;
              break;
            } else {
              match = true;
            }
          }
          if (match == true) {
            return { requireMatch: match };
          }
        }
      }
    } else {
      return null;
    }
  }

  private requireMatchPM(control: FormControl): ValidationErrors | null {
    const selection: any = control.value;
    let match = null;
    if (!isNullOrUndefined(selection) && selection != "") {
      if (!isNullOrUndefined(this.filteredPMList)) {
        for (var i = 0; i < this.filteredPMList.length; i++) {
          if (this.filteredPMList[i].pmDisplayName == selection) {
            match = null;
            break;
          } else {
            match = true;
          }
        }
        if (match == true) {
          return { requireMatchPM: match };
        }
      }
    } else {
      return null;
    }
  }

  private requireMatchSM(control: FormControl): ValidationErrors | null {
    const selection: any = control.value;
    let match = null;
    if (!isNullOrUndefined(selection) && selection != "") {
      if (!isNullOrUndefined(this.filteredSMList)) {
        for (var i = 0; i < this.filteredSMList.length; i++) {
          if (this.filteredSMList[i].smDisplayName == selection) {
            match = null;
            break;
          } else {
            match = true;
          }
        }
        if (match == true) {
          return { requireMatchSM: match };
        }
      }
    } else {
      return null;
    }
  }

  //Custom validation for Department(Mat autocomplete) to validate user text with departnents list
  //Returns true if user text is not found in department list
  private requireMatchDept(control: FormControl): ValidationErrors | null {
    const selectionDept: any = control.value;
    let match = null;
    if (!isNullOrUndefined(selectionDept) && selectionDept != "") {
      if (this.RequiredDept == true) {
        if (!isNullOrUndefined(this.departmentsList)) {
          for (var i = 0; i < this.departmentsList.length; i++) {
            if (this.departmentsList[i].DepartmentName == selectionDept) {
              match = null;
              break;
            } else {
              match = true;
            }
          }
          if (match == true) {
            return { requireMatchDept: match };
          }
        }
      }
    } else {
      return null;
    }
  }

  private requireMatchCadre(control: FormControl): ValidationErrors | null {
    const selectionCadre: any = control.value;
    let match = null;
    if (!isNullOrUndefined(selectionCadre) && selectionCadre != "") {
      if (this.RequiredCadre == true) {
        if (!isNullOrUndefined(this.cadresList)) {
          for (var i = 0; i < this.cadresList.length; i++) {
            if (this.cadresList[i].CadreName == selectionCadre) {
              match = null;
              break;
            } else {
              match = true;
            }
          }
          if (match == true) {
            return { requireMatchCadre: match };
          }
        }
      }
    } else {
      return null;
    }
  }

  //Custom validation for Techgroup(Mat autocomplete) to validate user text with techgroup list
  //Returns true if user text is not found in techgroup list
  private requireMatchTech(control: FormControl): ValidationErrors | null {
    const selectionTech: any = control.value;
    let match = null;
    if (!isNullOrUndefined(selectionTech) && selectionTech != "") {
      if (this.RequiredTech == true) {
        if (!isNullOrUndefined(this.techGroupList)) {
          for (var i = 0; i < this.techGroupList.length; i++) {
            if (this.techGroupList[i].GroupName == selectionTech) {
              match = null;
              break;
            } else {
              match = true;
            }
          }
          if (match == true) {
            return { requireMatchTech: match };
          }
        }
      }
    } else {
      return null;
    }
  }

  //Custom validation for Techgroup(Mat autocomplete) to validate user text with techgroup list
  //Returns true if user text is not found in techgroup list
  private requireMatchExp(control: FormControl): ValidationErrors | null {
    const selectionExp: any = control.value;
    let match = null;
    if (!isNullOrUndefined(selectionExp) && selectionExp != "") {
      if (this.RequiredExp == true) {
        if (!isNullOrUndefined(this.expertiseList)) {
          for (var i = 0; i < this.expertiseList.length; i++) {
            if (this.expertiseList[i].Value == selectionExp) {
              match = null;
              break;
            } else {
              match = true;
            }
          }
          if (match == true) {
            return { requireMatchExp: match };
          }
        }
      }
    } else {
      return null;
    }
  }
  emailDomain(control: AbstractControl): { [key: string]: any } | null {
    if (control.value != null) {
      const SecondaryEmail: string = control.value;
      const domain = SecondaryEmail.substring(
        SecondaryEmail.lastIndexOf("@") + 1
      );
      if (SecondaryEmail === "" || domain.toLowerCase() === "winwire.com") {
        return { emailDomain: true };
      } else {
        return null;
      }
    }
  }

  onPeopleManagerChange(ob) {
    const peopleManager = this.HREmp.peopleManagersHistoryDetails[0];
    peopleManager.pmDisplayName = ob.option.viewValue;
    peopleManager.ManagerCode = ob.option.value;
    const empobj = this.empList.find((x) => x.EmpCode === ob.option.value);
    this.HREmp.PeopleManagerCode = ob.option.value;
    peopleManager.DesignationName = empobj.DesignationName;
    peopleManager.ManagerDesignationID = empobj.DesignationId;
    peopleManager.DurationFrom =
      this.HREmp.DOJ != null
        ? new Date(
          this.datePipe.transform(this.HREmp.DOJ, this.config.dateFormat())
        )
        : new Date(
          this.datePipe.transform(new Date(), this.config.dateFormat())
        );
    peopleManager.CreatedDate = new Date(
      this.datePipe.transform(new Date(), this.config.dateFormat())
    );
    peopleManager.UpdatedDate = new Date(
      this.datePipe.transform(new Date(), this.config.dateFormat())
    );
  }

  getBasicEmployeeDetailsByCode(empCode) {
    this.empCode = empCode;
    this.isSaved = this.empCode == null ? false : true;
    if (this.empCode != null) {
      this.emp_Svc.getBasicEmployeeById(this.empCode).subscribe(
        (data: any) => {
          this.HrDetailsForm.get("EmployeeCode").disable();
          this.HrDetailsForm.get("OfficeMailId").disable();
          this.HREmp = data;
          if (this.HREmp.ProbationDate == null) {
            this.GetProbation(
              this.HREmp.DOJ,
              this.HREmp.TeamId,
              this.HREmp.EeTypeId
            );
          }

          if (this.HREmp.LocationID == 1 || this.HREmp.LocationID == 2) {
            this.disableDOE = true;
          } else this.disableDOE = false;
          if (!this.HREmp.CelebratedDOB) {
            this.HREmp.CelebratedDOB = this.HREmp.DOB;
          }
          //if (this.isProfile) {
          //  this.setJobLocation(this.HREmp.TeamId);
          //}
          if (
            this.HREmp.LocationID != null &&
            (this.HREmp.LocationID === 1 || this.HREmp.LocationID === 2) &&
            this.HREmp.JobLocationState == null
          ) {
            this.setJobLocationState();
          }
          if (this.HREmp.IsMigratedOnH1 && this.HREmp.DateOfExit != null) {
            this.setUSDOJ(this.HREmp.DateOfExit);
          }
          this.setTeam(this.HREmp.LocationID);
          var seniorManager = new SeniorManagersHistoryDetails();

          //this.HREmp.seniorManagersHistoryDetails.sort((a, b) => {
          //  const dateA = new Date(a.DurationTo);
          //  const dateB = new Date(b.DurationTo);
          //  return dateB.getTime() - dateA.getTime();
          //});

          this.HREmp.seniorManagersHistoryDetails =
            this.HREmp.seniorManagersHistoryDetails.slice(0, 1);
          if (this.HREmp.seniorManagersHistoryDetails.length == 0) {
            this.newAttribute = {
              ID: 0,
              DurationFrom: "",
              DurationTo: "",
              Name: "",
              Designation: "",
            };
            this.HREmp.seniorManagersHistoryDetails.push(this.newAttribute);
            this.newAttribute = {};
          }
          var peopleManager = new PeopleManagersHistoryDetails();

          //this.HREmp.peopleManagersHistoryDetails.sort((a, b) => {
          //  const dateA = new Date(a.DurationTo);
          //  const dateB = new Date(b.DurationTo);
          //  return dateB.getTime() - dateA.getTime();
          //});

          this.HREmp.peopleManagersHistoryDetails =
            this.HREmp.peopleManagersHistoryDetails.slice(0, 1);

          if (this.HREmp.peopleManagersHistoryDetails.length == 0) {
            this.newAttributepm = {
              ID: 0,
              DurationFrom: "",
              DurationTo: "",
              Name: "",
              Designation: "",
            };
            this.HREmp.peopleManagersHistoryDetails.push(this.newAttributepm);
            this.newAttributepm = {};
          }
          this.getEmployeeSMList();
          this.getEmployeeList();
          this.enableJoblocationState =
            this.isSaved && this.HREmp.JobLocationState != null ? false : true;
          this.enableLocation =
            this.isSaved && this.HREmp.LocationID != null ? false : true;
          this.enableDesignation =
            this.isSaved && this.HREmp.DesignationId != null ? false : true;
          this.enableCadre =
            this.isSaved && this.HREmp.CadreId != null ? false : true;
          this.enableDepartment =
            this.isSaved && this.HREmp.DepartmentId != null ? false : true;
          this.enableDivision =
            this.isSaved && this.HREmp.DivisionId != null ? false : true;
          this.enableSeniorManager =
            this.isSaved && this.HREmp.seniorManagersHistoryDetails[0].ID > 0
              ? false
              : true;
          this.enablePeopleManager =
            this.isSaved && this.HREmp.peopleManagersHistoryDetails[0].ID > 0
              ? false
              : true;
          if (!this.destroyed) this.cdr.detectChanges();

          this.designationsList.forEach((item) => {
            if (item.ID == this.HREmp.DesignationId) {
              this.designationId = item.DesignationName;
            }
          });
          this.departmentsList.forEach((item) => {
            if (item.ID == this.HREmp.DepartmentId) {
              this.departmentId = item.DepartmentName;
              this.enableExpertise =
                this.isSaved &&
                  this.departmentId == "Delivery" &&
                  this.HREmp.ExpertiseId != "" &&
                  this.HREmp.ExpertiseId != null
                  ? false
                  : true;
              this.enableTechgroup =
                this.isSaved &&
                  this.departmentId == "Delivery" &&
                  this.HREmp.TechGroupId != null
                  ? false
                  : true;
            }
          });
          this.cadresList.forEach((item) => {
            if (item.ID == this.HREmp.CadreId) {
              this.cadreId = item.CadreName;
            }
          });
          this.techGroupList.forEach((item) => {
            if (item.ID == this.HREmp.TechGroupId) {
              this.TechGroupId = item.GroupName;
            }
          });
          this.onSelectedTechGroupId();
          this.getCommunicationData();
          this.profileFields();
          this.HREmp.ExpertiseId = data.ExpertiseId.split(",");
          this.originalHrEmp = JSON.parse(JSON.stringify(this.HREmp));
          this.HrEmpOutput.emit(this.HREmp);
        },
        (error) => (this.error = error)
      );
    }
  }
  checkURL() {
    this.isInvalidUrl =
      this.HREmp.LinkedInID != null && this.HREmp.LinkedInID.trim() != ""
        ? !this.linkedInUrlPattern.test(this.HREmp.LinkedInID)
        : false;
  }

  onSeniorManagerChange(ob) {
    const seniorManager = this.HREmp.seniorManagersHistoryDetails[0];
    seniorManager.smDisplayName = ob.option.viewValue;
    seniorManager.SeniorManagerCode = ob.option.value;
    const empobj = this.empList.find((x) => x.EmpCode === ob.option.value);
    this.HREmp.PeopleManagerCode = ob.option.value;
    seniorManager.DesignationName = empobj.DesignationName;
    seniorManager.SeniorManagerDesignationID = empobj.DesignationId;
    seniorManager.DurationFrom = this.HREmp.DOJ
      ? new Date(
        this.datePipe.transform(this.HREmp.DOJ, this.config.dateFormat())
      )
      : new Date(this.datePipe.transform(new Date(), this.config.dateFormat()));
    seniorManager.CreatedDate = new Date(
      this.datePipe.transform(new Date(), this.config.dateFormat())
    );
    seniorManager.UpdatedDate = new Date(
      this.datePipe.transform(new Date(), this.config.dateFormat())
    );
  }

  handleResumeFile(event) {
    if (event.target.files == undefined) {
      this.HREmp.ResumeFile = null;
    }
    const files: FileList = event.target.files;
    if (files && files.length > 0) {
      if (!this.validFile(files[0])) {
        this.toastr.warning(
          "File name " + files[0].name + ": Not a valid file type."
        );
        // Clear the input
        event.srcElement.value = null;
        event.currentTarget.value = null;
      }
      // Don't allow file sizes over 1MB
      if (files[0].size < this.MAX_SIZE) {
        this.HREmp.ResumeFile = this.file_Svc.readAndUploadFile(files);
        this.HREmp.ResumeDocumentName = null;
        this.HREmp.ResumeDocumentPath = null;
      } else {
        this.toastr.warning(
          " File: " +
          files[0].name +
          " exceeds 1MB hence it cannot be uploaded."
        );
        // Clear the input
        event.srcElement.value = null;
        event.currentTarget.value = null;
      }
    }
  }

  fetchURl(url) {
    this.emp_Svc
      .getDownloadURL(url)
      .subscribe((data: any) => {
        window.open(data, '_blank');
      });
  }

  setDocName() {
    return this.HREmp.EmpCode + "_" + this.HREmp.NamePerRecords + "_Resume";
  }

  validFile(file: File) {
    let types = Resume_File_Types;
    return types.includes(file.type);
  }

  //deleteFieldSM(index) {
  //  const message = `Are you sure you want to delete?`;
  //  var deleteType = "Record";
  //  const dialogData = new ConfirmDialogModel(
  //    "Confirm Action",
  //    message,
  //    deleteType
  //  );
  //  const dialogRef = this.dialog.open(ConfirmDialogComponent, {
  //    maxWidth: "600px",
  //    data: dialogData,
  //  });
  //  dialogRef.afterClosed().subscribe(
  //    (dialogResult) => {
  //      if (dialogResult) {
  //        this.HREmp.seniorManagersHistoryDetails.splice(index, 1);
  //      }
  //      if (this.HREmp.seniorManagersHistoryDetails.length == 1) {
  //        this.HREmp.seniorManagersHistoryDetails[index - 1].DurationTo = null;
  //      }
  //      if (this.HREmp.seniorManagersHistoryDetails.length == index) {
  //        this.HREmp.seniorManagersHistoryDetails[index - 1].DurationTo = null;
  //      }
  //    },
  //    (error) => {
  //      this.result = error;
  //    }
  //  );
  //}
}
export class pmObj {
  pmDisplayName: string;
  pmEmpCode: number;
}
export class smObj {
  smDisplayName: string;
  smEmpCode: number;
}
